export { default } from './TotalDevices';
